import { render, staticRenderFns } from "./economicActivitySubClassifier.vue?vue&type=template&id=3af91e4d&scoped=true"
import script from "./economicActivitySubClassifier.vue?vue&type=script&lang=js"
export * from "./economicActivitySubClassifier.vue?vue&type=script&lang=js"
import style0 from "./economicActivitySubClassifier.vue?vue&type=style&index=0&id=3af91e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af91e4d",
  null
  
)

export default component.exports